<template>
  <div>
    <div class="content-step__button-list col-big-vspace">
      <button
        v-for="(option, index) in options"
        class="content-step__button-list__image-item"
        :class="active.hiddenName === option.hiddenName ? 'active': ''"
        :key="index"
        @click="change(option)"
      >
        <div class="svg" :class="color" v-html="option.svg"></div>
      </button>
    </div>
    <div class="col-xs-12 col-big-vtspace" v-if="active.name">
      <p class="tcenter"><span class="bold">Symbole sélectionné :</span> {{ active.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Object,
      default: () => {},
    },
    color: {
      type: String,
      default: '',
    }
  },
  methods: {
    change({name, hiddenName}) {
      this.$emit('change', {name, hiddenName});
    },
  },
};
</script>
